import { generateUniqueHash } from 'fela-utils';
export default function generateMonolithicClassName(style) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (style.className) {
    var name = prefix + style.className;
    delete style.className;
    return name;
  }

  var hashedName = generateUniqueHash(style);
  return '' + prefix + hashedName;
}